<template>
  <div id="add-topik">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group" id="add-topik-modal-select">
        <label for="inputTopik">Nama Topik <span class="text-danger">*</span></label>
        <select name="topik" id="selectTopik" v-model="selected_topic" class="form-control"></select>
      </div>
      <div class="form-group">
        <label for="inputKeyword">
          Kata Kunci <span class="text-danger">*</span>
        </label>
        <input type="text" id="inputKeyword" name="keyword" v-model="input_keyword" class="form-control"
          placeholder="Masukkan Kata Kunci" required />
        <small class="text-muted">
          <i class="bi bi-info-circle mr-1"></i> Gunakan tanda kutip untuk
          menjadikan kata kunci sebagai frasa
        </small>
      </div>
      <div class="form-group">
        <label for="inputExclude"> Pengecualian </label>
        <input type="text" id="inputExclude" name="exclude" v-model="input_exclude" class="form-control"
          placeholder="Masukkan Kata Kunci yang Dikecualikan" />
        <small class="text-muted">
          <i class="bi bi-info-circle mr-1"></i> Kata kunci yang di kecualikan akan
          dianggap sebagai frasa, gunakan koma untuk memisahkan setiap kata kunci
        </small>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-warning" :disabled="is_loading">
          Simpan
        </button>
      </div>
      <floating-loader-component v-if="is_loading" />
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";

$.pgNotification = notif;
export default {
  name: "modal_add_keyword",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      err: null,
      selected_topic: null,
      selected_tipe: null,
      input_keyword: "",
      input_exclude: "",
      is_loading: false,
      callback: this.data[0]?.callback ?? null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      tipe:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.project.project_detail.tipe
          : this.data[0]["tipe_project"],
    };
  },
  methods: {
    getTopic: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.is_loading = true;
      this.$http
        .get(api)
        .then(function (response) {
          self.is_loading = false;
          if (response.status == 200) {
            let resp = response.data;
            let topik = [];
            let topik_formed = [];
            let tpk;

            for (var key in resp.socmed) {
              tpk = {
                id: key + "-" + 1,
                text: resp.socmed[key],
              };
              topik.push(tpk);
            }

            for (key in resp.formed) {
              for (let t in resp.formed[key].topics) {
                tpk = {
                  id: t + "-" + 2,
                  text: resp.formed[key].topics[t],
                };
                topik_formed.push(tpk);
              }
            }

            self.topics = topik;
            self.selectedTopic = 0;
            let group_topic = [];

            if (self.tipe == 1) {
              if (self.data[0].tipe == 2) {
                group_topic.push({
                  text: "Media Online",
                  children: topik_formed,
                  element: HTMLOptGroupElement,
                });
              }
              if (self.data[0].tipe == 1) {
                group_topic.push({
                  text: "Media Sosial",
                  children: topik,
                  element: HTMLOptGroupElement,
                });
              }
            } else {
              let tmp = group_topic;
              group_topic = tmp.concat(topik);
            }

            $("#selectTopik")
              .select2({
                data: group_topic,
                width: "100%",
                placeholder: "Silahkan Pilih Topik",
                allowClear: true,
                dropdownParent: $('#modalSlideUp')
              })
              .val(self.selectedTopic)
              .trigger("change")
              .on("change", function () {
                let data = this.value.split("-");
                self.selectTopic(data[0], data[1]);
              });
          }
        })
        .catch(function (err) {
          self.err = err.response;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    selectTopic: function (value, tipe) {
      this.selected_topic = value;
      this.selected_tipe = parseInt(tipe);
    },
    submitForm: function () {
      let self = this;
      self.$store.dispatch("loading", true);
      let params = {
        keyword: this.$sanitize(this.input_keyword),
        excludes: this.$sanitize(this.input_exclude),
        _id: this.selected_topic,
        tipe: this.selected_tipe,
        id_project: this.id_project,
      };
      let api = process.env.VUE_APP_API_URL + "new-keyword-add";
      this.is_loading = true;
      this.$http
        .post(api, params)
        .then(function (response) {
          if (response.status == 200) {
            if (self.callback) {
              self.callback()
            }
            self.$parent.$parent.getKeyword();
            if (self.tipe == 2) {
              self.$parent.$parent.$parent.$parent.getChannelStatus();
            }
            self.topik = null;
            $("#modalSlideUp").modal("hide");
            if (response.data.status == "Keyword already exists") {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Keyword telah tersedia',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            } else {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Keyword berhasil ditambahkan!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
            self.$store.dispatch("loading", false);
          } else {
            $("#modalSlideUp").modal("hide");
            self.$store.dispatch("loading", false);
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                  response.data.status,
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          }
        })
        .catch(function (error) {
          console.log(error)
          $("#modalSlideUp").modal("hide");
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                error.response?.data.status ?? "Problem",
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          self.$store.dispatch("loading", false);
          this.is_loading = false;
        });
    },
  },
  mounted: function () {
    let self = this;
    $(function () {
      self.getTopic();
    });
  },
};
</script>

<style scoped>
.form-control select {
  -webkit-appearance: button;
  cursor: pointer;
}
</style>
